

import { FC, useMemo } from 'react';

import { IHasChildren } from '../../common/types/IHasChildren';
import DefaultClient from '../../../api/DefaultClient';
import ServiceStackClientContext from '../../../contexts/api/ServiceStackContext';


interface IServiceStackClientProviderProps extends IHasChildren {
    baseUrl?: string;
    basePath?: string;    
}

const ServiceStackClientProvider: FC<IServiceStackClientProviderProps> = ({
    children,
    baseUrl,
    basePath
}) => {
    const client = useMemo(() => {
        return DefaultClient(baseUrl, basePath);
    }, [baseUrl, basePath]);

    return (
        <ServiceStackClientContext.Provider value={client}>
            {children}
        </ServiceStackClientContext.Provider>
    )
}

export default ServiceStackClientProvider